import { getPlatform, getProductId } from '@/infrastructure/product-info';
import { DATONG_EVENT_NAME } from '@/infrastructure/reporter/datong/constant';
import { reporter } from '@/infrastructure/reporter/datong/index';
import {
  reportDtClick,
  reportDtPgIn,
  reportDtPgOut,
  useDtReportPage,
} from '@raft/utils/src/datong';

/**
 * 页面切入上报
 * @param pgid
 */
export const reportPgIn = (pgid: string) => reportDtPgIn(reporter, {
  pgid,
  productId: getProductId(),
  rm_platform: getPlatform(),
});

/**
 * 页面切出上报
 * @param pgid
 * @param duration
 */
export const reportPgOut = (pgid: string, duration = 0) => reportDtPgOut(reporter, {
  pgid,
  custom_pgout_pgid: pgid,
  custom_pgout_duration: duration,
  productId: getProductId(),
  rm_platform: getPlatform(),
}, duration);

/**
 * 点击上报
 * @param module 一般情况下为 pgId
 * @param action
 * @param optional
 */
export const reportClick = (
  module: string,
  action: string,
  optional?: {
    from?: string,
    cost?: number,
    result?: number,
    param1?: number,
    param2?: number,
    param3?: string,
    param4?: string,
  },
) => reportDtClick(reporter, module, action, optional);

/**
 * 页面上报 hook
 * @param pgid
 */
export const useReportPage = (pgid: string) => useDtReportPage(reporter, {
  pgid,
  productId: getProductId(),
  rm_platform: getPlatform(),
});

/**
 * @deprecated 已废弃，使用 reportClick
 */
export const reportElement = (
  element: HTMLElement | string,
  pgid: string,
  eid: string,
  params: { [key: string]: string},
) => {
  reporter?.reportElement(element, {
    pgid,
    eventName: DATONG_EVENT_NAME.click,
    businessParams: {
      eid,
      ...params,
    },
  });
};
